import {Component, ElementRef, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NbDialogService, NbToastrService} from '@nebular/theme';
//import {NgxSpinnerService} from 'ngx-spinner';
import {ActivatedRoute, Router, Params} from '@angular/router';
import {LocalDataSource} from 'ng2-smart-table';
import {MainService} from '../../../../services/main.service';
import * as S3 from "aws-sdk/clients/s3";

@Component({
  selector: 'app-edit-empresa',
  templateUrl: './edit-empresa.component.html',
  styleUrls: ['./edit-empresa.component.scss']
})
export class EditEmpresaComponent implements OnInit {
  bucket: S3 = new S3({
    accessKeyId: "AKIAUT7IXVID4CI4XZVD",
    secretAccessKey: "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",
    region: "us-east-1"
  });
  frmEmpresa: FormGroup;
  submitted = false;
  changeImg= false;
  img: any;
  imagen: any = [""];
  loading = false;
  EmpresaID: any;
  listaIMG: any[] = [];
  ListaFotos: any = [""];
  empresa = {
    padre:'',
    tipo:'',
    nit: '',
    nombre: '',
    ciudad: '',
    contacto: '',
    email: '',
    pagina: '',
    telefonoA: '',
    telefonoB: '',
    direccion: '',
    img: '',
  };
  LastID: any;
 ListType: any[];
 padre_Select = false;
 Cod_padre: any;
  constructor(private toastrService: NbToastrService,
    public router: Router,
    private dialogService: NbDialogService,
    private rutaActiva: ActivatedRoute,
    public mainService: MainService,
    public fb: FormBuilder,
    //private spinner: NgxSpinnerService
    ) { 
      this.EmpresaID = this.rutaActiva.snapshot.params.id;
      console.log(this.EmpresaID)
      this.getEmpresa(this.EmpresaID);
      this.frmEmpresa = this.fb.group({
        tipo: ['', [Validators.required]],
        nit: [''],
        nombre: [''],
        ciudad: [''],
        contacto: [''],
        email: [''],
        pagina: [''],
        telefonoA: [''],
        telefonoB: [''],
        direccion: [''],
        padre: [''],

    });
    }

  ngOnInit() {
  }
  get valoresCrear() {
    return this.frmEmpresa.controls;
}

getEmpresa(id) {
    this.mainService.get('tadmEmpresa/'+id).subscribe(result => {
      if (result) {
        console.log(result);
        this.Cod_padre = result.padre;
        this.empresa.padre = result.padre;
        this.empresa.tipo = result.tipo;
        this.empresa.nit = result.nit_empresa;
        this.empresa.nombre = result.nombre_empresa;
        this.empresa.ciudad = result.ciudad_empresa;
        this.empresa.contacto = result.contacto_empresa;
        this.empresa.email = result.email_empresa;
        this.empresa.pagina = result.pagina_web_empresa;
        this.empresa.telefonoA = result.telefono1_empresa;
        this.empresa.telefonoB = result.telefono2_empresa;
        this.empresa.direccion = result.direccion_empresa;
        this.empresa.img= result.id_imagen_mongo_empresa;
        console.log(this.empresa);
        console.log(this.Cod_padre);
        this.callType(result.tipo)
        //let img = { src: result.id_imagen_mongo_empresa };
        //this.listaIMG.push(img);
        //console.log(this.listaIMG)
      } else {
        console.log("Error al insertar en Sql");
      }
    })
}
DeleteIMG() {
  this.empresa.img = '';
  //this.listaIMG = [];
}

readUrl(event: any) {
  //this.modImg = true;
  this.changeImg = true;
  this.imagen = event.target.files[0];
  console.log(this.imagen);
  if (event.target.files && event.target.files[0]) {
    var reader = new FileReader();
    reader.onload = (event: ProgressEvent) => {
      let img = (<FileReader>event.target).result ;
      console.log(img)
      this.listaIMG.push(img);
      this.empresa.img= this.listaIMG[0];
      //this.listaIMG[0].src = (<FileReader> event.target).result;
    };
    reader.readAsDataURL(event.target.files[0]);
  }
}
onGoTo() {
  this.router.navigate(["dashboard/empresas"]);
}
makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
save() {
  this.loading = true;
  if(this.changeImg === true){
    this.listaIMG = [];
    var params = {
      Bucket: "printech-resources",
      ACL: "public-read",
      Key: this.makeid(8) + this.imagen.name.trim(),
      ContentType: this.imagen.type,
      Body: this.imagen
    };
    var options = {
      // Part Size of 10mb
      partSize: 10 * 1024 * 1024,
      queueSize: 1,
      // Give the owner of the bucket full control
      ACL: "public-read"
    };
    const self = this;
    var uploader = this.bucket.upload(params, options, function(err, data) {
      if (err) {
        console.log("PERDIDAS");
        this.loadingImage = false;
      }
      console.log("SUCCESS");
      console.log(data);
      self.ListaFotos[0] = data.Location.toString();
      console.log(self.ListaFotos);
      self.saveEmp();
    });
    uploader.on("httpUploadProgress", function(event) {
      console.log("UPDATE");
      console.log(event);
      var total = (event.loaded * 100) / event.total;
      console.log(total);
    });
    return;
  }else{
    this.saveEmp();
  }
 
}
callType(typeEmp){
  console.log(typeEmp);
switch(typeEmp) {
  case 'Empresa':
    this.mainService.get('tadmSelectType/Grupo').subscribe(value => {
      console.log(value);
      this.ListType = value;
      this.padre_Select = true;
      console.log(this.padre_Select)
    })
    break;
    case 'Predio':
      this.mainService.get('tadmSelectType/Empresa').subscribe(value => {
        console.log(value);
        this.ListType = value;
        this.padre_Select = true;
        console.log(this.padre_Select)
      })
    break;
  default:
    // code block
  }
}
saveEmp() {
  this.submitted = true;
  if (this.frmEmpresa.invalid) {
      return false;
  }
  //this.spinner.show();
  let emp = this.frmEmpresa.value;
  console.log(emp);
  if(this.frmEmpresa.value.padre === ''){
    this.Cod_padre= 0;
  }else{
    this.Cod_padre= this.frmEmpresa.value.padre;
  }
  console.log(emp);
  if(this.changeImg === true){
     this.img = this.ListaFotos[0];
  }else{
    this.img = emp.id_imagen_mongo_empresa;
  }
  let insert = {
    padre: this.Cod_padre,
    pais:'Colombia',
    tipo: emp.tipo,
    nit_empresa: emp.nit,
    nombre_empresa: emp.nombre,
    ciudad_empresa: emp.ciudad,
    contacto_empresa: emp.contacto,
    email_empresa: emp.email,
    pagina_web_empresa: emp.pagina,
    telefono1_empresa: emp.telefonoA,
    telefono2_empresa: emp.telefonoB,
    direccion_empresa: emp.direccion,
    id_imagen_mongo_empresa: this.img,
  }
  console.log(insert);
  this.mainService.put('tadmEmpresa/'+ this.EmpresaID, insert).subscribe(result => {
      console.log(result);
      if (result) {
          console.log('Se ha insertado');
          this.frmEmpresa.reset();
          this.submitted = false;
          //this.spinner.hide();
          this.loading = false;
          this.changeImg = false;

          this.showToast('top-right', 'success', 'Success!', 'It was created successfully!');
          this.getEmpresa(this.EmpresaID);
          return true;

      } else {
          console.log('Error');
          this.frmEmpresa.reset();
          this.submitted = false;
          //this.spinner.hide();
          this.loading = false;
          this.changeImg = false;

          this.showToast('top-right', 'warning', 'Error!', 'Error creating!');
          this.getEmpresa(this.EmpresaID);
          return false;
      }
  });
}
showToast(position, status, titulo, mensaje) {
  this.toastrService.show(mensaje, titulo, { position, status });
}
}
